






























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() visible!: boolean;
  @Prop() orderId!: number;
  dialogVisible: boolean = false;
  @Watch("visible")
  visibleChange(v: boolean) {
    this.dialogVisible = v;
  }
  toDetail() {
    if (!this.orderId) {
      return false;
    }
    this.handleCloseDialog();
  }
  handleCloseDialog() {
    if (this.$route.name === "orderManageDetail") {
      this.$emit("update:visible", false);
      this.$emit("close", false);
    } else {
      this.$router.replace({
        name: "orderManageDetail",
        query: {
          id: String(this.orderId),
        },
      });
    }
  }
}
